module.exports = "<mat-toolbar>\r\n</mat-toolbar>\r\n"